import {
  RETURN_PARSED_RESUME_REQUEST,
  RETURN_PARSED_RESUME_SUCCESS,
  RETURN_PARSED_RESUME_FAILURE,
  RETURN_PARSED_RESUME_RESET,
} from "../../actionTypes";

export const returnParsedResumeRequest = (type) => ({
  type: RETURN_PARSED_RESUME_REQUEST,
  payload: type,
});

export const returnParsedResumeSuccess = (data) => ({
  type: RETURN_PARSED_RESUME_SUCCESS,
  payload: data,
});

export const returnParsedResumeFailure = (error) => ({
  type: RETURN_PARSED_RESUME_FAILURE,
  payload: error,
});

export const returnParsedResumeReset = () => ({
  type: RETURN_PARSED_RESUME_RESET,
});
